import { DirectDresonRuleResolveEvent, DresonRuleResolveEvent } from "../../types/FilterTypes";
import { eventQBus } from "../../types/EventQBus";
import { selection } from "../selection/Selection";

export default class FilterResolveDresonRule {
  public static async resolve(event: DresonRuleResolveEvent | DirectDresonRuleResolveEvent) {
    if (event.historic || !event.formData) {
      await selection
        .assignLegacy(
          {
            rule: event.rule,
            page: event.page,
            ...(event.entryRule !== undefined ? { entryRule: event.entryRule } : {}),
          },
          { event },
        )
        .catch(FilterResolveDresonRule.handleError);
      return;
    }

    await selection
      .resolveLegacy(FilterResolveDresonRule.resolveInput(event.formData), { entryRule: event.entryRule })
      .catch(FilterResolveDresonRule.handleError);
  }

  private static resolveInput(formData: FormData): Record<string, string | string[]> {
    const input: Record<string, string | string[]> = {};
    for (const [key, value] of formData) {
      if (typeof value !== "string") {
        throw new Error(`Unsupported selection field "${key}"`);
      }

      const previous = input[key];
      input[key] = previous === undefined ? value : Array.isArray(previous) ? [...previous, value] : [previous, value];
    }

    if (typeof input.rule !== "string") {
      throw new Error("Invalid rule");
    }

    return input;
  }

  private static handleError(): void {
    eventQBus.emit("ftfind.dresonRule.resolveAborted");
  }
}
